import * as types from '../types.js';
import { bindBlockReasonFromKind } from '../utils/movement-kind-reason.js';

export default {

	html: `
		<style>
			#sm-reason #movement_kind { width: 20rem; }
			#sm-reason #reason { width: 28rem; background: #f3f4f6; cursor: default; }
		</style>
		<form id="sm-reason" class="form" autocomplete="off">
			<div class="title">Motivo da operação</div>
			<p class="mts muted" style="max-width:36rem">O <strong>Motivo</strong> é preenchido automaticamente pela <strong>Natureza</strong> (não é texto livre). APIs e relatórios continuam recebendo o campo Motivo.</p>
			<div class="fsb mtl">
				<label>Natureza<sup>*</sup>
					<input id="movement_kind" type="text" list="movement_kind_list" required>
				</label>
				<label title="Espelho da Natureza (somente leitura)">Motivo
					<input id="reason" type="text" readonly tabindex="-1" placeholder="Preenchido automaticamente pela Natureza">
				</label>
			</div>
			<div class="fsb mtm">
				<span></span>
				<span>
					<button type="button" class='bn_Escape button'>Fechar</button>
					<button type="button" class='bn_Enter button'>Confirmar</button>
				</span>
			</div>
		</form>
	`,

	form: {
		selector: '#sm-reason',
		init(formset) {
			formset.form.eraseValues();
			Object.getPrototypeOf(this).init.call(this);
			bindBlockReasonFromKind(formset);
		},
	},

	fields: [
		{ properties: { selector: '#movement_kind' }, types: [ types.opt_movement_kind(), types.datalist() ] },
		{ properties: { selector: '#reason' }, types: [] },
	],
};
